import {
  ApiResponse,
  PaginatedResponse,
  Document,
  DocumentUploadForm,
} from '@/types';
import api, { resolvedBaseURL } from './client';

// Documents API
export const documentsAPI = {
  list: async (params?: {
    page?: number;
    limit?: number;
    reportType?: string;
    reportId?: string;
    reportIds?: string[];
    playerId?: string;
  }): Promise<PaginatedResponse<Document>> => {
    const sp = new URLSearchParams();
    if (params?.page) sp.append('page', String(params.page));
    if (params?.limit) sp.append('limit', String(params.limit));
    if (params?.reportType) sp.append('report_type', params.reportType);
    if (params?.reportId) sp.append('report_id', params.reportId);
    if (params?.reportIds?.length) sp.append('report_ids', params.reportIds.join(','));
    if (params?.playerId) sp.append('player_id', params.playerId);
    const response = await api.get(`/documents?${sp.toString()}`);
    return response.data;
  },
  getById: async (id: string): Promise<ApiResponse<Document>> => {
    const response = await api.get(`/documents/${id}`);
    return response.data;
  },
  upload: async (form: DocumentUploadForm): Promise<ApiResponse<Document>> => {
    const formData = new FormData();
    formData.append('file', form.file);
    formData.append('title', form.title);
    formData.append('category', form.category);
    if (form.reportType) formData.append('report_type', form.reportType);
    if (form.reportId) formData.append('report_id', form.reportId);
    if (form.playerId) formData.append('player_id', form.playerId);
    if (form.notes) formData.append('notes', form.notes);
    if (form.documentDate) formData.append('document_date', form.documentDate);
    const response = await api.post('/documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await api.delete(`/documents/${id}`);
  },
  getViewUrl: (id: string): string => {
    return `${resolvedBaseURL}/documents/${id}/view`;
  },
  getDownloadUrl: (id: string): string => {
    return `${resolvedBaseURL}/documents/${id}/download`;
  },
  fetchBlob: async (id: string): Promise<Blob> => {
    const response = await api.get(`/documents/${id}/view`, {
      responseType: 'blob',
    });
    return response.data;
  },
  fetchDownloadBlob: async (id: string): Promise<Blob> => {
    const response = await api.get(`/documents/${id}/download`, { responseType: 'blob' });
    return response.data;
  },
};
